export const booksSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "itemListElement": [
    {
      "@type": "Book",
      "name": "A Los Angeles Comedy",
      "author": {
        "@type": "Person",
        "name": "Laura Novak"
      },
      "description": "Welcome to Downtown LA, where the rent is high, the stakes are higher, and the neighbors are the highest of all. A hilarious and heartwarming ode to chosen family and chosen city.",
      "genre": "Comedy Fiction",
      "inLanguage": "en",
      "bookFormat": "http://schema.org/Paperback"
    },
    {
      "@type": "Book",
      "name": "Murder at the Mailbox",
      "author": {
        "@type": "Person",
        "name": "Laura Novak"
      },
      "datePublished": "2016",
      "description": "A Clari Drake Mystery. Clari Drake returns, pursuing a spanking good story into the darkest corners of the city everyone loves to laugh at.",
      "genre": "Mystery Fiction",
      "inLanguage": "en",
      "bookFormat": "http://schema.org/Paperback",
      "image": "https://customer-assets-39nsmqrw.emergentagent.net/job_laura-nova-author/artifacts/n2xuspre_MurderAtTheMailbox-cover-sRGB.webp"
    },
    {
      "@type": "Book",
      "name": "Finding Clarity",
      "author": {
        "@type": "Person",
        "name": "Laura Novak"
      },
      "datePublished": "2015",
      "description": "The first novel Introducing Clari Drake in the People's Republic of Berkeley. A laugh-out-loud romp that blends satire and mystery.",
      "genre": "Mystery Fiction",
      "inLanguage": "en",
      "bookFormat": "http://schema.org/Paperback",
      "image": "https://customer-assets.emergentagent.com/job_laura-nova-author/artifacts/ncvfsh5e_FindingClarity.jpg"
    }
  ]
};

export const booksData = [
  {
    id: 1,
    title: 'Nora\'s Story',
    subtitle: 'A Downtown LA Comedy',
    description: 'Welcome to Downtown LA, where the rent is high, the stakes are higher, and the neighbors are the highest of all. A hilarious and heartwarming ode to chosen family and chosen city.',
    fullDescription: 'Welcome to Downtown LA where the rent is high, the stakes are higher, and the neighbors are the highest of all. Nora is a proper surgeon\'s wife who travels to Los Angeles from her posh home in San Francisco to settle a real estate deal while grappling with her own issues of empty nest syndrome. She quickly becomes entangled with a gaggle of quirky Angelenos, each one dripping with ambition, sexual desire, and something that might stick to your shoes. Together they navigate the city\'s wild terrain of real estate roulette, relationship misadventures, and one crazy idea for a porn site that might just be crazy enough to change Nora\'s life.\n\nThis upmarket screwball comedy about Los Angeles offers readers the urban ensemble charm of Armistead Maupin\'s <em>Tales of the City</em> series with the misfit entourage trope of Amazon\'s <em>The Outlaws</em>.\n\nThe novel is a fun, fast read with bite-size chapters that has been developmentally edited by an Emmy Award-winning comedy writer and instructor at UCLA ... a humorous and heartwarming ode to the messy beauty of not only one\'s chosen family, but one\'s chosen city.',
    coverImage: null,
    bgColor: 'bg-emerald-50',
    buttonColor: 'bg-emerald-600 hover:bg-emerald-700',
    year: 'Coming Soon',
    status: 'Big Laughs in LA',
    purchaseLink: null,
    sampleLink: null
  },
  {
    id: 2,
    title: 'Murder at the Mailbox',
    subtitle: 'A Clari Drake Mystery',
    description: 'Clari Drake returns, pursuing a spanking good story into the darkest corners of the city everyone loves to laugh at. Join Clari on deadline as she investigates the intersection of lust, betrayal and — podiatry in The People\'s Republic.',
    fullDescription: 'A seemingly ordinary day turns deadly when a body is discovered at a neighborhood mailbox. As Clari investigates, she uncovers a tangled web of neighborhood feuds, hidden relationships, and long-buried secrets. This mystery brings crime reporting experience to vivid fictional life.',
    coverImage: 'https://customer-assets-39nsmqrw.emergentagent.net/job_laura-nova-author/artifacts/n2xuspre_MurderAtTheMailbox-cover-sRGB.webp',
    bgColor: 'bg-orange-50',
    buttonColor: 'bg-orange-600 hover:bg-orange-700',
    year: '2016',
    status: 'Available Now',
    purchaseLink: 'https://www.amazon.com/Murder-Mailbox-Clari-Drake-Mystery-ebook/dp/B01N030ZLR',
    sampleLink: '/murder-at-the-mailbox-sample'
  },
  {
    id: 3,
    title: 'Finding Clarity',
    subtitle: 'A Clari Drake Mystery',
    description: 'The first novel Introducing Clari Drake in the People\'s Republic of Berkeley. A laugh-out-loud romp that blends satire and mystery in the city of Birkenstocks and woolen socks.',
    fullDescription: 'Clari Drake is a failed TV reporter-turned-troublemaker mom caught in a world of progressive politics, social climbers, and tech wealth. With her quirky sidekicks, Clari uncovers a web of fraud, fake identity, and gender-bending secrets at her son\'s posh academy, forcing her to confront her own limits and the elite she loves to hate.',
    coverImage: 'https://customer-assets.emergentagent.com/job_laura-nova-author/artifacts/ncvfsh5e_FindingClarity.jpg',
    bgColor: 'bg-indigo-50',
    buttonColor: 'bg-indigo-600 hover:bg-indigo-700',
    year: '2015',
    status: 'Available Now',
    purchaseLink: 'https://www.amazon.com/Finding-Clarity-Clari-Drake-Mystery-ebook/dp/B00THVLHHY',
    sampleLink: '/finding-clarity-sample'
  }
];
